import styled from 'styled-components';

type InactiveSourcingAdProps = {
  isDisabled?: boolean;
};

/**
 * Shared inactive (sold / unavailable) visual treatment for sourcing ads —
 * the image column of the list card (`CarImageColumn`) and table rows.
 */
export const InactiveSourcingAd = styled.div<InactiveSourcingAdProps>`
  opacity: ${({isDisabled}) => (isDisabled ? 0.75 : 1)};
  filter: ${({isDisabled}) => (isDisabled ? 'grayscale(1)' : 'grayscale(0)')};
  transition:
    opacity 1200ms ease,
    filter 1200ms ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
